"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiumicino": {
    "12ee9c66": [{
      "hkey": "b365b90e",
      "slug": "le-vignole-aeroporto",
      "name": "Le Vignole-Aeroporto",
      "primary": true,
      "skipSearch": false
    }],
    "aeroporto-leonardo-da-vinci": [{
      "hkey": "b365b90e",
      "slug": "le-vignole-aeroporto",
      "name": "Le Vignole-Aeroporto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiumicino"
    }],
    "6c8f207d": [{
      "hkey": "b365b90e",
      "slug": "le-vignole-aeroporto",
      "name": "Le Vignole-Aeroporto",
      "primary": true,
      "skipSearch": false
    }],
    "le-vignole": [{
      "hkey": "b365b90e",
      "slug": "le-vignole-aeroporto",
      "name": "Le Vignole-Aeroporto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "36bc502b": [{
      "hkey": "863d3d86",
      "slug": "palidoro-tre-denari",
      "name": "Palidoro-Tre Denari",
      "primary": true,
      "skipSearch": false
    }],
    "palidoro": [{
      "hkey": "863d3d86",
      "slug": "palidoro-tre-denari",
      "name": "Palidoro-Tre Denari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4fd140c9": [{
      "hkey": "863d3d86",
      "slug": "palidoro-tre-denari",
      "name": "Palidoro-Tre Denari",
      "primary": true,
      "skipSearch": false
    }],
    "torreinpietra": [{
      "hkey": "863d3d86",
      "slug": "palidoro-tre-denari",
      "name": "Palidoro-Tre Denari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiumicino"
    }],
    "53ce089e": [{
      "hkey": "bb1caa87",
      "slug": "tragliata-tragliatella",
      "name": "Tragliata-Tragliatella",
      "primary": true,
      "skipSearch": false
    }],
    "tragliata": [{
      "hkey": "bb1caa87",
      "slug": "tragliata-tragliatella",
      "name": "Tragliata-Tragliatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiumicino"
    }],
    "c35ccdf9": [{
      "hkey": "bb1caa87",
      "slug": "tragliata-tragliatella",
      "name": "Tragliata-Tragliatella",
      "primary": true,
      "skipSearch": false
    }],
    "tragliatella": [{
      "hkey": "bb1caa87",
      "slug": "tragliata-tragliatella",
      "name": "Tragliata-Tragliatella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fiumicino"
    }]
  }
};
exports["default"] = _default;